import React from 'react';

import { observer } from 'mobx-react';

import classes from './SelfBillingPlanStep.module.scss';
import { AccountDetailsWidget } from '../../../../../../customer-management';
import { CurrentPlanInfo } from '../../../components/CurrentPlanInfo/CurrentPlanInfo';
import { SubmitButton } from '../../../components/SubmitButton/SubmitButton';
import { scanIqStore } from '../../../../../stores/scanIqStore';
import { entitySignUpStore } from '../../../../../../shared/stores/entity/entitySignUpStore';
import { getCurrentUrl, goTo } from '../../../../../../shared/utils/angularUtils';
import { pathQueryParams } from '../../../../../../payment';
import { SCAN_IQ_PAYMENT_RESULT_TYPE } from '../../../../../../payment/constants/scanIqPaymentResultType';

const SelfBillingPlanStep = observer(() => {
  const { customer } = scanIqStore;
  const { entityId, entityName } = entitySignUpStore;

  if (!customer?.activeSubscription || !entityName) {
    throw new Error('Customer or entity info is not set');
  }

  const onSubmit = () => {
    const currentUrl = getCurrentUrl();
    goTo('/scaniq-payment-result', {
      params: {
        [pathQueryParams.entityId]: entityId,
        [pathQueryParams.redirectStatus]: 'succeeded',
        [pathQueryParams.retryPath]: currentUrl,
        [pathQueryParams.paymentResultType]: SCAN_IQ_PAYMENT_RESULT_TYPE.FREE,
      },
    });
  };

  return (
    <div className={classes.contentContainer}>
      <AccountDetailsWidget
        firstName={customer.firstName}
        lastName={customer.lastName}
        entityName={entityName}
        inbodyId={customer.inbodyId}
        dateOfBirth={customer.dateOfBirth}
        gender={customer.gender}
      />
      <CurrentPlanInfo
        subscriptionName={customer.activeSubscription.name}
        billingPeriodType={customer.activeSubscription.billingPeriodType}
      />
      <SubmitButton onSubmit={onSubmit} />
    </div>
  );
});

export { SelfBillingPlanStep };
